module.exports = __webpack_public_path__ + "img/iphone_scan_2.696d44d6.gif";